// @flow
import * as types from "../ACTIONS/commonActionTypes";
import initialState from './commonInitialState';

export default function sampleTypeReducer(state = initialState.sampleTypes, ourClientId:number, action) {

    switch (action.type) {

        case types.GOT_SAMPLE_TYPES_LIST:
            return {
                initialized: true,
                items: action.sampleTypes
            };
        default:
            return state;
    }
}
